import { render, staticRenderFns } from "./PlanicieAlagavelPantanal.vue?vue&type=template&id=6d9f478f&lang=pug"
import script from "./PlanicieAlagavelPantanal.vue?vue&type=script&lang=js"
export * from "./PlanicieAlagavelPantanal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports